import React from "react";

export const LazyMicrosoftGraphConnectedSurveillanceAppPage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "MicrosoftGraphConnectedSurveillanceApp" */ "./MicrosoftGraphConnectedSurveillanceApp"
        )
);
